import {
  createTheme,
  type ThemeOptions,
  type Theme as MaterialTheme,
} from '@mui/material';
import { isNil } from 'lodash';

import { palette } from './palette';

export type ThemeName = keyof typeof Theme.list;

export class Theme {
  /**
   * The available themes.
   */

  // @mrabdolian: TODO: implement dark/light variants for each theme.
  static readonly list = {
    green: {
      palette: {
        primary: {
          main: palette.green,
        },
        secondary: {
          main: palette.lightGreen,
        },
      } as ThemeOptions,
    },

    blue: {
      palette: {
        primary: {
          main: palette.blue,
        },
        secondary: {
          main: palette.lightYellow,
        },
      } as ThemeOptions,
    },

    pink: {
      palette: {
        primary: {
          main: palette.pink,
        },
        secondary: {
          main: palette.lightGreen,
        },
      } as ThemeOptions,
    },
  } as const;

  /**
   * Gets the options of a theme by its name.
   * @param name Name of the theme
   */
  protected static getOptions(name: ThemeName): ThemeOptions | undefined {
    return Theme.list[name];
  }

  static get availableThemes(): Array<ThemeName> {
    return Object.keys(Theme.list) as Array<ThemeName>;
  }

  /**
   * Creates a MUI theme by its name.
   * @param name Name of the theme
   * @see Theme.list
   */
  static create(name: ThemeName): MaterialTheme {
    const themeOptions = Theme.getOptions(name);

    if (isNil(themeOptions)) {
      throw new Error(`Theme with name "${name}" does not exist.`);
    }

    return createTheme(themeOptions);
  }
}
